export const environment = {
   production: false,
   canonicalDomain: 'https://dev.porvenirsofipo.mx',
   apiKeys: {
      googleMaps: 'AIzaSyBhUXUjJQX4t--4EEY5pRIm8GrEPEyVIA8'
   }
};
